import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The `hire-job-requisitions` LaunchDarkly release flag (the SDK camelCases the
 * key to `hireJobRequisitions`).
 *
 * Gates every Job Requisition frontend surface — sidebar nav, routes, the
 * Settings → Approval Config tab, and the "Create Job" entry-point change — so
 * the whole workflow ships dark and stays invisible in prod until the flag is
 * switched on. This is the engineering release gate (deploy ≠ release) and is
 * temporary: it is removed at GA, after which the per-org `ApprovalConfig.enabled`
 * product toggle is the sole control.
 *
 * Introduced here for TP-1589 / TP-1598 ahead of the deferred nav ticket
 * (TP-1593); it is the single source of truth for the flag so all surfaces
 * light up together.
 */
export const useHireJobRequisitionsFlag = (): boolean => {
  const { hireJobRequisitions } = useFlags();
  return Boolean(hireJobRequisitions);
};
